import { useMesfRealtime } from "@dexteel/mesf-core";
import { useQueryClient } from "@tanstack/react-query";
import { MILL_1, MILL_2 } from "@/setup/mill-config/mill-config";

const SP_TO_ASSET_ID: Record<string, number> = {
	"M1.GetIncentiveByWeek": MILL_1.id,
	"M1.GetIncentiveReport": MILL_1.id,
	"M2.GetIncentiveByWeek": MILL_2.id,
	"M2.GetIncentiveReport": MILL_2.id,
};

const SP_TO_QUERY_NAME: Record<string, string> = {
	"M1.GetIncentiveByWeek": "incentive",
	"M1.GetIncentiveReport": "incentive-report",
	"M2.GetIncentiveByWeek": "incentive",
	"M2.GetIncentiveReport": "incentive-report",
};

const normalizeRealtimeMessage = (message: string) =>
	message.replaceAll("[", "").replaceAll("]", "");

export const useIncentiveRealtimeInvalidation = (assetId: number) => {
	const queryClient = useQueryClient();

	useMesfRealtime({
		onReceiveMessage: async (_author, rawMessage) => {
			const message = normalizeRealtimeMessage(rawMessage);
			const messageAssetId = SP_TO_ASSET_ID[message];
			const queryName = SP_TO_QUERY_NAME[message];

			if (!messageAssetId || !queryName || messageAssetId !== assetId) return;

			await queryClient.invalidateQueries({ queryKey: [queryName, assetId] });
		},
	});
};
